export default __webpack_public_path__ + "assets/c55e1dcbca0c6a7776440670a93754ae.woff2";